import PostLayout from "../../layout/post-layout/PostLayout";

const CommonComponent = (props) => {
    const { items } = props;

    const commonLayout = (
        <div className="common-component">
            {Object.values(items).map((result, index) => {
                return (
                    <PostLayout
                        key={index}
                        date={result.date}
                        description={result.description}
                        subText={result.subText}
                        showMore={result.showMore}
                        image={result.image}
                        imageCover={result.imageCover}
                        video={result.video}
                        link={result.link}
                        filter={result.filter}
                        points={result.points}
                        cards={result.cards}
                        highlights={result.highlights}
                        hashtag={result.hashtag}
                    />
                );
            })}
        </div>
    );

    return commonLayout;
};

export default CommonComponent;
